<template>
  <c-container>
    <center style="margin-top: 24px;">
        <p>ご予約を承りました。</p>
        <br />
        <a :href="rootRoute"><p>トップに戻る></p></a>
    </center>
  </c-container>
</template>

<script>
import page from '@/mixins/page'

export default {
  name: 'Completed',
  mixins: [
    page('予約確定')
  ],
  computed: {
    rootRoute () {
      return this.getters['org/topURL']
    }
  }
}
</script>
